import styled from "styled-components";
import { Close } from "@material-ui/icons"

export const Container = styled.div`
  padding: 8px;
`;

export const Title = styled.h1`
  font-size: 16px;
  font-weight: 600;
  margin: 8px 0;
  width: 95%;
`;

export const ContentWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: start;
  flex-wrap: wrap;
`;

export const ImgWrapper = styled.figure`
  width: 25%;
  height: auto;
  flex-shrink: 0;
  box-sizing: border-box;
  opacity: ${({selected}) => selected ? '1' : '0.65'};
  transition: 0.4s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: unset;
`;

export const Frame = styled.div`
  width: calc(25vw - 8px);
  height: calc(25vw - 8px);
  max-width: 150px;
  max-height: 150px;
  min-width: 80px;
  min-height: 80px;
  padding: ${({selected}) => selected ? '0' : '5px'};
  transition: 0.4s;
`;

export const Img = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  background-image: url(${({src}) => src});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

export const FigCaption = styled.figcaption`
  font-size: 12px;
  text-align: center;
`;

export const Wrapper = styled.div`
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
`;

export const CloseIcon = styled(Close)`
  border-radius: 50%;
  border: solid 1px;
  font-size: 20px!important;
  margin: 8px;
  position: absolute;
  right: 8px;
  top: 16px;
`;